export const announcements = [
  {
    id: 1,
    href: "https://www.nmpa.gov.cn/xxgk/ggtg/ypggtg/ypqtggtg/20251211142951156.html",
    name: "国家药品监督管理局关于马来酸依那普利口服溶液说明书增加儿童用药信息的公告（2025年第118号）"
  },
  {
    id: 2,
    href: "https://www.nmpa.gov.cn/xxgk/ggtg/ypggtg/zhybhpzh/zhybhpzhgg/20251212150847199.html",
    name: "中药保护品种公告（第32号）（2025年 第116号）"
  },
  {
    id: 3,
    href: "https://www.nmpa.gov.cn/xxgk/ggtg/ypggtg/ypqtggtg/20251024163830184.html",
    name: "国家药监局关于复方公英胶囊转换为非处方药的公告（2025年第104号）"
  },
  {
    id: 4,
    href: "https://www.nmpa.gov.cn/xxgk/ggtg/ypggtg/ypchj/ypgjjgg/20251204101148121.html",
    name: "国家药监局关于35批次不符合规定药品的通告（2025年第43号）"
  },
  {
    id: 5,
    href: "https://www.nmpa.gov.cn/xxgk/ggtg/ypggtg/ypqtggtg/20251118150906125.html",
    name: "国家药监局关于发布仿制药参比制剂目录（第九十八批）的通告（2025年第40号）"
  },
  {
    id: 6,
    href: "https://www.nmpa.gov.cn/xxgk/fgwj/gzwj/gzwjyp/20240105160921188.html",
    name: "国家药监局综合司关于印发药品网络交易第三方平台检查指南（试行）的通知药监综药管函〔2023〕691号"
  },
  {
    id: 7,
    href: "https://www.nmpa.gov.cn/xxgk/fgwj/gzwj/gzwjyp/20230626093940190.html",
    name: "国家药监局综合司关于规范处方药网络销售信息展示的通知药监综药管函〔2023〕333号"
  },
  {
    id: 8,
    href: "https://yjj.beijing.gov.cn/yjj/zwgk20/zcwj91/436479294/index.html",
    name: "京药监发〔2023〕238号"
  },
  {
    id: 9,
    href: "https://yjj.beijing.gov.cn/yjj/zwgk20/zcwj91/436479162/index.html",
    name: "京药监发〔2023〕26号"
  },
  {
    id: 10,
    href: "https://www.nmpa.gov.cn/xxgk/fgwj/gzwj/gzwjyp/20221130200007127.html",
    name: "国家药监局综合司关于做好《药品网络销售监督管理办法》贯彻落实工作的通知药监综药管函〔2022〕667号"
  },
  {
    id: 11,
    href: "https://yjj.beijing.gov.cn/yjj/zwgk20/zcwj91/543343466/index.html",
    name: "京食药监药械〔2018〕10号"
  }
]
